/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type { CommonResponse, EmptyResponse } from '@/types/responseModel';
import type {
  AdditionalPackageInfo,
  BillingInvoicesListItem,
  CreatePaymentRequest,
  CurrentPlanDetail,
  PackageDetailInfo,
  SelfOpenAIKeyInfo,
  SubscribeState,
  SubscriptionPayment,
  SubscriptionUsageCount,
  SubscriptionUsageManageConfig,
  SubscriptionUsagePerDayList,
  UpdateSelfOpenAIKey,
  UpdateSubscription
} from '@/types/subscription';
import { Request } from '@/utils/request';

/**
 * 当前订阅的包
 * @returns
 */
export function subscribeUsagePackage() {
  return Request<CommonResponse<SubscribeState[]>>({
    url: '/rest/os/subscribe/usage/pkg/data',
    method: 'get'
  });
}

export function subscribeUsageCount() {
  return Request<CommonResponse<SubscriptionUsageCount>>({
    url: '/rest/os/subscribe/usage/current/turn/data',
    method: 'get'
  });
}

export function subscribeUsageManageConfig() {
  return Request<CommonResponse<SubscriptionUsageManageConfig>>({
    url: '/rest/os/subscribe/usage/bill/config/query',
    method: 'get'
  });
}

export function savedSubscribeUsageManageConfig(data: SubscriptionUsageManageConfig) {
  return Request<CommonResponse<SubscriptionUsageManageConfig>>({
    url: '/rest/os/subscribe/usage/bill/config/add/or/update',
    method: 'post',
    data
  });
}

export function subscribeUsageList(startTime: string, endTime: string) {
  return Request<CommonResponse<SubscriptionUsagePerDayList>>({
    url: '/rest/os/subscribe/usage/history/bar/data',
    method: 'get',
    params: {
      startTime,
      endTime
    }
  });
}

export function subscriptionBillList() {
  return Request<CommonResponse<BillingInvoicesListItem[]>>({
    url: '/rest/os/subscribe/billing/invoices/acquire',
    method: 'post'
  });
}

export function subscriptionExportToEmail() {
  return Request<EmptyResponse>({
    url: '/rest/os/subscribe/pricing/mailbox/export',
    method: 'post'
  });
}

export function subscriptionExportToFile() {
  return Request<CommonResponse<string>>({
    url: '/rest/os/subscribe/pricing/file/export',
    method: 'post'
  });
}

export function createPay(data: CreatePaymentRequest) {
  return Request<CommonResponse<string>>({
    url: '/rest/os/stripe/session/pay/link/create',
    method: 'post',
    data
  });
}

export function updateSubscription(data: UpdateSubscription) {
  return Request<CommonResponse<string>>({
    url: '/rest/os/stripe/subscription/update',
    method: 'post',
    data
  });
}

export function updatePlan(data: UpdateSubscription) {
  return Request<CommonResponse<SubscriptionPayment>>({
    url: '/rest/os/stripe/subscription/plan/update',
    method: 'post',
    data
  });
}

export function fetchAdditionalPackageInfo() {
  return Request<CommonResponse<AdditionalPackageInfo>>({
    url: '/rest/os/subscribe/pricing/supply/query',
    method: 'get'
  });
}

export function fetchSelfOpenAIKey() {
  return Request<CommonResponse<SelfOpenAIKeyInfo>>({
    url: '/rest/os/key/query',
    method: 'get'
  });
}

export function updateSelfOpenAIKey(data: UpdateSelfOpenAIKey) {
  return Request<EmptyResponse>({
    url: '/rest/os/key/save/or/update2',
    method: 'post',
    data
  });
}

export function fetchBillingUrl(returnUrl: string) {
  return Request<CommonResponse<string>>({
    url: '/rest/os/subscribe/billing/invoice/url?returnUrl=' + returnUrl,
    method: 'get'
  });
}

export function cancelSubscriptionPlan() {
  return Request<EmptyResponse>({
    url: '/rest/os/stripe/subscription/plan/cancel',
    method: 'post'
  });
}

export function usageDetail() {
  return Request<CommonResponse<CurrentPlanDetail>>({
    url: '/rest/os/subscribe/usage/detail',
    method: 'get'
  });
}

export function subscriptionDetailList() {
  return Request<CommonResponse<PackageDetailInfo[]>>({
    url: '/rest/os/subscribe/pricing/price/list',
    method: 'get'
  });
}
